<div [formGroup]="form" class="icon">
  <mat-form-field appearance="outline" style="width: 120px !important;">
    <mat-label>Range</mat-label>
    <app-ranger formControlName="range" required (ngModelChange)="onChangeValue($event, value)"></app-ranger>
    <button matSuffix mat-icon-button aria-label="Close" (click)="onClick($event)">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
